import React, { useState, useCallback, useEffect } from "react";
import Icon from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import _ from "lodash/fp";
import cx from "classnames";

const ProductImages = ({ images }) => {
  const [selectedImage, setSelectedImage] = useState(images[0]);
  useEffect(() => {
    setSelectedImage(images[0]);
  }, [images]);
  const onSelectImage = useCallback(
    image => () => {
      setSelectedImage(image);
    },
    [setSelectedImage]
  );
  return (
    <div className="product-images">
      <div className="container">
        <div className="row mb-3">
          <div className="col">
            <img className="image-big" src={`${process.env.REACT_APP_API_URL}/${selectedImage.path}`} alt={selectedImage.name} />
          </div>
        </div>
      </div>
      <div className="container images-container">
        <div className="indicator indicator-left">
          <Icon icon="chevron-left" />
        </div>
        <div className="indicator indicator-right">
          <Icon icon="chevron-right" />
        </div>
        <div className="row text-center">
          {_.map(image => {
            const classNames = cx({
              "image-selected": selectedImage.name === image.name
            });
            return (
              <div
                key={image.name + image.id}
                onClick={onSelectImage(image)}
                className="col-4"
              >
                <img
                  className={`image-small selectable ${classNames}`.trim()}
                  src={`${process.env.REACT_APP_API_URL}/${image.path}`}
                  alt={image.name}
                />
              </div>
            );
          }, images)}
        </div>
      </div>
    </div>
  );
};

ProductImages.propTypes = {
  images: PropTypes.array.isRequired
};

export default ProductImages;
